import { createAsyncThunk } from '@reduxjs/toolkit';
import { genericSupplierApiUrl } from 'Services/Apis/clients';
import axios from 'axios';

export const getParticipantGroup = createAsyncThunk(
  'participantGroupApi/getParticipantGroup',
  async (param, { getState }) => {
    const { user } = getState().oidc;

    const customHeaders = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
      'x-tenant': user.profile['custom:campaign_id'],
      'x-cachekey': user.profile['custom:catalog_id'],
    };

    const response = await axios.get(
      `${genericSupplierApiUrl}/ParticipantGroup`,
      { headers: customHeaders },
    );

    localStorage.setItem('participantGroup', JSON.stringify(response));

    return response.data;
  }
)
